import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";

import {FeatureFlagsProvider, getResolvedFeatureFlags} from "@pg-mono/amplitude";
import {getBugsnagErrorBoundary, initClientBugsnag} from "@pg-mono/bugsnag-client";

import {App} from "../../features/km_app/App";
import {bugsnagReleaseStage} from "../../features/km_app/utils/read_environment_variables";

initClientBugsnag("c7ea0b6e3135b76b495c67002d8d2249", bugsnagReleaseStage);

const BugsnagErrorBoundary = getBugsnagErrorBoundary();

export const renderClientApp = () => {
    const root = createRoot(document.getElementById("root") as HTMLElement);

    root.render(
        <BugsnagErrorBoundary>
            <FeatureFlagsProvider flags={getResolvedFeatureFlags()}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </FeatureFlagsProvider>
        </BugsnagErrorBoundary>
    );
};
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";

import {FeatureFlagsProvider, getResolvedFeatureFlags} from "@pg-mono/amplitude";
import {getBugsnagErrorBoundary, initClientBugsnag} from "@pg-mono/bugsnag-client";

import {App} from "../../features/km_app/App";
import {bugsnagReleaseStage} from "../../features/km_app/utils/read_environment_variables";

initClientBugsnag("c7ea0b6e3135b76b495c67002d8d2249", bugsnagReleaseStage);

const BugsnagErrorBoundary = getBugsnagErrorBoundary();

export const renderClientApp = () => {
    const root = createRoot(document.getElementById("root") as HTMLElement);

    root.render(
        <BugsnagErrorBoundary>
            <FeatureFlagsProvider flags={getResolvedFeatureFlags()}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </FeatureFlagsProvider>
        </BugsnagErrorBoundary>
    );
};
